
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { Contact, GroupUserExternal } from '../../../backend/backendapi';
import { Like } from '../../../../util/Like';
import { paginationOptions, searchOptions, selectOptions } from '../../../../util/vue-good-table';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import ContactStore from '../../../../stores/ContactStore';
import { ExternalUserSelectModalTabFunctions } from './ExternalUserSelectModalTab';

@Component({
  components: {
    VueGoodTable,
  },
})
export default class TabContacts extends Vue implements ExternalUserSelectModalTabFunctions {
  private selectedRows: GroupUserExternal[] = [];
  readonly store = new ContactStore();

  get columnsConfig(): any[] {
    return [{
      label: this.$t('firstname').toString(),
      field: (e: Contact) => e.firstName,
    }, {
      label: this.$t('lastname').toString(),
      field: (e: Contact) => e.lastName,
    }, {
      label: this.$t('email').toString(),
      field: (e: Contact) => e.email,
    }, {
      label: this.$t('salutation').toString(),
      field: (e: Contact) => e.salutation,
    }];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  get selectOptions(): any {
    return selectOptions(this.$i18n);
  }

  onSelectionChanged(params: { selectedRows: Like<Contact>[] }): void {
    this.selectedRows = params.selectedRows.map(e => GroupUserExternal.fromJS({
      firstName: e.firstName,
      lastName: e.lastName,
      email: e.email,
      salutation: e.salutation,
      company: e.company,
      mediaId: e.mediaId,
    }));
  }

  //passthroughs
  clear(): void {
    this.store.loadIfAbsent();
    this.selectedRows = [];
    (this.$refs.table as VueGoodTable).reset();
  }

  get selectedUsers(): GroupUserExternal[] {
    return this.selectedRows;
  }
}
